@if (isInitial || isLoaded) {
  <form
    (dragend)="dragging = false"
    (dragenter)="dragging = true"
    (dragleave)="dragging = false"
    [ngClass]="{ dragging: dragging, loaded: isLoaded, disabled: disabled }"
    class="dropzone clickable"
    enctype="multipart/form-data"
    id="dropzone">
    <input
      #fileInput
      id="file-input"
      (change)="filesChange($event)"
      class="input-file"
      [accept]="accept"
      [multiple]="multiple"
      [disabled]="disabled"
      type="file" />
    @if (!isLoaded) {
      <div class="message">
        <div class="dropzone-custom-content">
          @if (!readonly) {
            @if (IS_TRS_PROJECT) {
              <h3 class="dropzone-custom-title">{{ title || "generic.drop.dragDropTitle" | translate }}</h3>
              <div class="subtitle">{{ definition || "generic.drop.dragDropDefinition" | translate }}</div>
            } @else if (IS_PRODUCT_SAFETY_PROJECT) {
              <h3 class="dropzone-custom-title">{{ "generic.drop.dragDropTitle" | translate }}</h3>
              <div class="subtitle">{{ "generic.drop.dragDropDefinition" | translate }}</div>
            }
          }
        </div>
      </div>
    } @else {
      @for (file of value; track file) {
        <div class="preview">
          <span class="file icon-document-pdf" (click)="isIReportDocument(file) && itemHandler.emit(file)"></span>
          <div class="metadata">
            <span>{{ file.name }}</span>
            <span>{{ file.lastModified | date }}</span>
            <span>{{ file.size | filesize }}</span>
          </div>
          @if (!readonly) {
            <span class="delete-button icon-close-large" (click)="removeFile(file)"></span>
          }
        </div>
      }
    }
  </form>
}
